import { Injectable, signal, inject } from '@angular/core';

// Importar directamente las traducciones
import esTranslations from '../../../assets/i18n/es.json';
import enTranslations from '../../../assets/i18n/en.json';
import { GlobalStore } from '@store/global.state';

@Injectable({
  providedIn: 'root'
})
export class I18nService {
  private translations = {
    es: esTranslations,
    en: enTranslations
  };
  
  currentLanguage = signal<'es' | 'en'>('es');
  private globalStore = inject(GlobalStore);

  constructor() {
    // Ya no necesitamos cargar nada
  }

  translate(key: any, params?: Record<string, any>): string {
    // Si key no es una cadena, devolver el valor tal como está
    if (typeof key !== 'string') {
      return String(key);
    }
    
    const keys = key.split('.');
    let value: any = this.translations[this.currentLanguage()];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    if (typeof value !== 'string') {
      return key;
    }
    
    if (params) {
      return Object.keys(params).reduce((text, param) => 
        text.replace(`{{${param}}}`, params[param]), value
      );
    }
    
    return value;
  }

  setLanguage(lang: 'es' | 'en') {
    this.currentLanguage.set(lang);
    this.globalStore.loadMasterTypes().then(() => {
      
    });
  }
}